export default {
	checkbox: false,
	sso: true,
	'create-account': true,
	'forgot-password': true,
	sms: true,
	maintenance: false,
	maintenanceMessage: false,
	maintenanceMessageString: 'common.maintenanceMessage',
	mandatory2fa: true,
	casl: true,
	confirmLogin: false,
	snowplow: true,
};
